import { GenderType } from '@/utils/genders'
import { AxiosInstance } from 'axios'
import { Page, Pageable } from '@/types'
import { Horse } from '@/api/ifce'
import axiosInstance from '.'

export interface MinimalHorseDto {
  name: string
  birthday: string
  father?: MinimalHorseDto
}
export interface HorseFilter {
  name?: string,
  gender?: GenderType | GenderType[],
  year?: number | number[],
  motherName?: string,
}

class HorseApi {
  private axios: AxiosInstance

  constructor(axios: AxiosInstance) {
    this.axios = axios
  }

  public async get(filter: string, genders: GenderType[]): Promise<MinimalHorseDto[]> {
    return (await this.axios.get('/horse', {
      params: {
        filter,
        genders: genders.join(','),
      },
    })).data
  }

  public async getAll(filter: HorseFilter, page: Pageable): Promise<Page<Horse>> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line no-undef
    return (await this.axios.get('/horse/filter', { params: { ...filter, ...page } })).data
  }
}

export const horseApi = new HorseApi(axiosInstance)
